import { ViewStyle } from "react-native";
import { Colors } from "./ColorConfig";

export const ButtonStyles = {
  primaryButton: {
    borderRadius: 28,
    paddingVertical: 20,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  } as ViewStyle,
  secondaryButton: {
    backgroundColor: "#BCCD48",
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 24,
    justifyContent: "center",
    alignItems: "center",
  } as ViewStyle,

  // Add other button styles here...
};
